<template>
  <!-- star -->

  <div class="youjiaopage_wrap">
    <navBar />

    <banner2 :banner-h="h1" :banner-p="p1" :banner-img="Img1" />
    <!-- 面包屑 -->
    <div class="Crumbs">
      <div>当前位置：首页>
        <router-link to="/news">
          <span>新闻中心</span>
        </router-link>
      </div>
    </div>
    <!--  -->
    <div class="NewsDetails">
      <div class="NewsDetails_cont">
        <div class="NewsDetails_cont_title">
          <h1>{{articleInfo.title}}</h1>
          <div class="NewsDetails_cont_title_span">
            <img src="../assets/img/newsDetail/矩形.png" alt="" /><span
              >发布时间：{{articleInfo.add_time}}
            </span>
            <img src="../assets/img/newsDetail/矩形(1).png" alt="" /><span
              >浏览次数：{{articleInfo.visit}}
            </span>
          </div>
        </div>
        <div class="NewsDetails_cont_text" v-html="articleInfo.content">
        </div>
<!--        <div class="NewsDetails_cont_img">-->
<!--          <img-->
<!--            :src="articleInfo.image_input[0]"-->
<!--            alt=""-->
<!--          />-->
<!--        </div>-->
        <!-- 上一篇 下一篇 -->
        <!-- <Next ref="childData"></Next> -->
      </div>
    </div>

    <footer2 />

    <!-- end -->
  </div>
</template>

<script>
import footer2 from "../components/footer.vue";
import banner2 from "../components/banner.vue";
export default {
  name: "Keji",
  components: {
    footer2,
    banner2,
  },
  data() {
    return {
      h1: "企业新闻",
      Img1: require("../assets/img/banner2.png"),
      // 这是我在父的组件里 定义的变量 表示当前是数组里第1个页面
      artcleID: 0,
      p1: "更多最新精彩资讯，感受企业魅力",
      articleInfo:''
    };
  },
  created() {
    this.artcleId = this.$route.query.newsId;
    this.newsDetail();
  },
  methods: {
    newsDetail(){
      let that = this;
      this.reqApi.getNewsDetail(that.artcleId,(res)=>{
        console.log('文章详情',res)
        that.articleInfo = res
      },(err)=>{
        //业务错误返回
        console.log(err)
      })
    },
  },
};
</script>
<style scoped>
@charset "utf-8";

.youjiaopage_wrap {
  width: 100vw;
  margin: 0 auto;
  height: 1000px;
}
/* 面包屑 */
.Crumbs {
  width: 1200px;
  height: 46px;
  margin: 0 auto;
}
.Crumbs {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
.Crumbs div {
  line-height: 46px;
}
.Crumbs span {
  color: #000000;
}
/* 新闻详情 */
.NewsDetails_cont {
  width: 1200px;
  margin: 0 auto;
}
.NewsDetails_cont_title > h1 {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2b2b2b;
  line-height: 33px;
  margin-top: 78px;
  text-align: center;
}
.NewsDetails_cont_title img {
  vertical-align: middle;
}
.NewsDetails_cont_title_span {
  text-align: center;

  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a3a3a3;
  line-height: 30px;
  margin-top: 8px;
}
.NewsDetails_cont_text {
  margin-top: 40px;
  border-top: 1px solid #eaeaea;
}
.NewsDetails_cont_text p {
  line-height: 30px;
  width: 1000px;
  margin: 40px 100px;
}
.NewsDetails_cont_text div {
  margin-left: 90px;
  font-size: 24px;
  font-weight: bold;
}
.NewsDetails_cont_img {
  text-align: center;
  margin-bottom: 40px;
}

.NewsDetails_cont_btm {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm div {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 33px;
}
.NewsDetails_cont_btm p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.NewsDetails_cont_btm2 {
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm2_1 {
  margin: 32px 0;
  padding: 31px 61px 31px 20px;
  width: 507px;
  height: 123px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
}
.NewsDetails_cont_btm2_1 div {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 25px;
}
.NewsDetails_cont_btm2_1 p {
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}
</style>
